// import HomeBannerSection from "@/containers/HomeContainer/components/RenewalVersion/HomeBannerSection";
// import { ContentCarouselSection } from "@/containers/HomeContainer/components/RequestVersion/ContentCarouselSection";
// import { useRouter } from "next/router";
// import { MatchRecommendationFacilitySection } from "./MatchRecommendationFacilitySection";
// import { MatchRecommendationParlorSection } from "./MatchRecommendationParlorSection";

import {
  // Button,
  Box,
  HStack,
} from "@chakra-ui/react";

import dayjs from "dayjs";
import {
  CircleImage,
  ColorIcon,
  colors,
  customEvent,
  EventProps,
  HLine,
  LargeButton,
  LARGEL_BUTTON_TYPE,
  Link,
  NextLink,
  Spacing,
  Starring,
  VStack,
} from "goi_common";

import styled from "@emotion/styled";
import { css } from "@emotion/react";

import { bestGoiReviews } from "../constants/bestGoiReviews";
import { ReviewTagChip } from "@/containers/ReviewContainer/components/ReviewTag/ReviewTagChip";
import { NewReview } from "@/containers/ReviewContainer/remotes/getReviews";

export const MatchRecommendationParlorAndFacilitySection = () => {
  return (
    <VStack>
      {/* <VStack width="100%" padding="24px 24px">
        <Box className="subtitle_16_sb gray800">
          장례 비용을 만원 단위까지 알려드리는 이곳은
          <br /> <b>투명하고 정직한 장례</b>를 약속하는
          <br />
          고이장례연구소입니다.
        </Box>
      </VStack> */}
      <Spacing gap={12} />

      {/* <ContentCarouselSection path="match_recommendation_detail" /> */}

      <VStack width="100%" margin="10px 0">
        <HStack justifyContent="center" alignItems="start" gap="12px" width="100%">
          <Box className="subtitle_16_b warmGray800" width="100%" padding="0 0 0 24px">
            다른 상주님들은 어떻게 장례를 진행하셨는지
            <br />
            후기를 통해 확인해보세요
          </Box>
        </HStack>
      </VStack>

      <VStack gap="12px">
        {bestGoiReviews?.map((review) => (
          <ReviewCard
            key={review?.id}
            review={review}
            id={review?.id}
            event={{
              newGtm: {
                path: "match_recommendation_detail",
                trigger_and_target: "card-uv_review_detail",
              },
            }}
          />
        ))}
      </VStack>
      <Spacing gap={20} />
      <HStack justifyContent="center">
        <NextLink
          href="https://www.goifuneral.co.kr/review/"
          css={{ width: "327px" }}
          event={{
            newGtm: {
              path: "match_recommendation_detail",
              trigger_and_target: "CTA-uv_review",
            },
          }}
        >
          <LargeButton className="button_16_sb" buttonType={LARGEL_BUTTON_TYPE.ORANGE} height={50}>
            더 많은 후기 보기
          </LargeButton>
        </NextLink>
      </HStack>
    </VStack>
  );
};

export const ReviewCard = ({
  review,
  id,
  currentTag,
  event,
}: {
  review: typeof bestGoiReviews[0] | NewReview;
  id: number;
  currentTag?: string;
  event: EventProps;
}) => {
  return (
    <VStack width="100%" padding="0 24px">
      <HStack padding="24px 0 0 0" alignItems="center">
        <CircleImage src={review.user.picture} radius={48} />
        <VStack margin="0 0 0 12px" width="calc(100% - 80px)">
          <HStack justifyContent="space-between">
            <Box className="body3_m" color={colors.gray700}>
              {review.user.nickname}
            </Box>
          </HStack>

          <Box className="body3_r" color={colors.gray500} mt="2px">
            {review.user.age_and_gender || "비공개"}
            {" | "}
            {dayjs(review.created_at).format("YYYY년 M월 D일")}
          </Box>
        </VStack>
      </HStack>
      <Link
        href={`/review/${id}/`}
        onClick={() => {
          event && customEvent(event);
        }}
      >
        <Box mt="20px" className="subtitle2_sb" color={colors.black}>
          {review.headline}
        </Box>
      </Link>

      <Spacing gap={10} />
      <VStack gap={4}>
        <Link
          href={`/review/${id}/`}
          onClick={() => {
            event && customEvent(event);
          }}
        >
          <EllipsisDiv
            className="body2"
            color={colors.gray700}
            dangerouslySetInnerHTML={{ __html: review.good }}
            headlineLength={0}
          />
        </Link>
      </VStack>
      <Box mt="20px" display="flex" alignItems="center">
        <Box mr="6px">
          <span className="button">{review.score}</span>
        </Box>
        <Starring star={review.score} size="16px" gap="1px" />
        <HStack
          justifyContent="end"
          alignItems="center"
          width="100%"
          style={{ color: colors.warmGray700 }}
          className="body3_m gray900"
          as="button"
        >
          <Link
            href={`/review/${id}/`}
            onClick={() => {
              event && customEvent(event);
            }}
          >
            자세히보기
          </Link>
          <ColorIcon name="icon-arrow-right-circle-mono" color={colors.warmGray700} size={16} />
        </HStack>
      </Box>

      {review.tags && review.tags.length > 0 && (
        <HStack maxWidth="100%" overflowX="scroll" mt="18px" gap={0}>
          {review.tags.map((tag) => (
            <ReviewTagChip
              key={tag}
              tag={tag}
              colorType={currentTag === tag ? "highlight" : "normal"}
            />
          ))}
        </HStack>
      )}
      <Box mt="14px" mb="22px" />
      <HLine width="100%" color={colors.gray100} />
    </VStack>
  );
};

const EllipsisDiv = styled.div<{ headlineLength: number }>`
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  white-space: pre-wrap;
  ${({ headlineLength }) =>
    css`
      -webkit-line-clamp: ${12 - Math.floor(headlineLength / 13)};
    `}
`;

// export const LegacyMatchRecommendationParlorAndFacilitySection = () => {
//   const router = useRouter();

//   return (
//     <VStack>
//       <VStack width="100%" padding="24px 12px 24px">
//         <Box className="subtitle_16_sb gray800">
//           잠깐!
//           <br />
//           장례 절차를 모르는 경황없는 순간부터
//           <br />몇 백만원 차이가 발생하기 시작한다는 사실.
//         </Box>
//       </VStack>

//       <Box padding="0 0 24px">
//         <Button
//           style={{
//             color: colors.gray800,
//             width: "100%",
//             height: "80px",
//             backgroundColor: colors.gray900,
//             borderRadius: "0px",
//           }}
//           onClick={() => {
//             customEvent({
//               newGtm: {
//                 path: "mtch_recomm_dtl",
//                 trigger_and_target: "funeral_prepare_6",
//               },
//             });
//             router.push(`/funeral-prepare/6/`);
//           }}
//         >
//           <HStack
//             gap={1}
//             width="100%"
//             alignItems="center"
//             justifyContent="space-between"
//             padding="12px 0"
//           >
//             <Box textAlign="start" className="subtitle_18_sb white">
//               장례식장에 연락하기 전,
//               <br />
//               반드시 확인해야 할 3가지
//             </Box>
//             <ColorIcon color={colors.white} size={12} name="arrow" />
//           </HStack>
//         </Button>
//       </Box>

//       <VStack width="100%">
//         <HStack
//           justifyContent="center"
//           background={colors.orange650}
//           padding="16px 24px"
//           alignItems="start"
//           gap="12px"
//           width="100%"
//         >
//           <Box className="body_16_m white" width="100%">
//             장례 비용을 만원 단위까지 알려드리는 이곳은
//             <br /> <b>투명하고 정직한 장례</b>를 약속하는
//             <br />
//             <HStack width="100%" alignItems="center" justifyContent="space-between">
//               <div>
//                 <b>고이장례연구소</b>입니다.
//               </div>
//               <Box>
//                 <Button
//                   style={{
//                     height: "28px",
//                     borderRadius: "16px",
//                     backgroundColor: colors.warmGray100,
//                     padding: "6px 14px",
//                     boxShadow: "2px 2px 2px #00000022",
//                   }}
//                   onClick={() => {
//                     router.push("/funeral-prepare/company-introduction/");
//                     customEvent({
//                       newGtm: {
//                         path: "parlor_match_request",
//                         trigger_and_target: "uv_compnay_introduction",
//                       },
//                     });
//                   }}
//                 >
//                   <HStack alignItems="center" gap="10px" height="12px">
//                     <div className="caption_12_sb black">더 알아보기</div>{" "}
//                     <ColorIcon name="icon-arrow-right-small-mono" color={colors.black} size={12} />
//                   </HStack>
//                 </Button>
//               </Box>
//             </HStack>
//           </Box>
//         </HStack>
// <ContentCarouselSection path="match_request" />
//       </VStack>
//       <HomeBannerSection path="match_request" />
//       <VStack background={colors.warmGray100}>
//         <Box padding="24px 12px">
//           <MatchRecommendationParlorSection />
//         </Box>
//       </VStack>

//       <VStack margin="14px 20px">
//         <MatchRecommendationFacilitySection />
//       </VStack>
//     </VStack>
//   );
// };
